import merge from 'lodash/merge'

import { useBuilder } from '@/lib/builder/extension/useBuilder'

import { type ReservationEmbedSection } from '../../../WebsiteBuilder.types'

const websiteBuilderQueue = useBuilder('websiteBuilder')

const ReservationEmbedCommands = {
  updateBlock: websiteBuilderQueue.createBlockCommand<ReservationEmbedSection>({
    commit: async (currentData, ctx) => {
      return merge(currentData, ctx.update)
    },
  }),
}

export { ReservationEmbedCommands }
